import { css } from '@/styled-system/css';

export const highlightsContainer = css({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '1x',
});

export const triggerContainer = css({
  marginTop: '2x',
});
